import { GridValidRowModel } from '@mui/x-data-grid'
import { convertSecondsToISODate } from '../formatDate'

export const convertRowSecondsToISODate = (
  row: GridValidRowModel,
): GridValidRowModel => {
  return Object.fromEntries(
    Object.entries(row).map(([key, value]) => [
      key,
      convertSecondsToISODate(value),
    ]),
  )
}
